import PropTypes from 'prop-types';

import { Sparklines, SparklinesCurve } from 'react-sparklines';

const SparkLine = ({ data, timespan }) => {

  return (

      <div className=" sm:p-4">
        {data &&
          <>
            <Sparklines data={data} limit={data.length} width={400} height={80} margin={2} >
              <SparklinesCurve color="#253e56" />
            </Sparklines>
            <div className="text-center text-gray-500">{timespan}</div>
          </>
        }
      </div>
  );
};

SparkLine.propTypes = {
  data: PropTypes.array,
};

export default SparkLine;
